import { SearchOutlined } from '@ant-design/icons';
import { PriceTableProduct } from '@models/PriceTableProduct';
import { Table, Typography } from 'antd';
import TableFilters from '../../../../components/TableFilters';

const { Text } = Typography;

interface TabProductProps {
  priceTableProducts: PriceTableProduct[];
}

const TabProduct: React.FC<TabProductProps> = ({ priceTableProducts }) => {
  const columns = [
    {
      title: 'Código',
      dataIndex: 'productCode',
      width: '20%',
      align: 'center' as 'center',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <TableFilters
          inputPlaceholder={'Filtrar pelo Cód.'}
          inputValue={selectedKeys[0]}
          onChangeInputValue={setSelectedKeys}
          onFilter={confirm}
          onClearFilters={clearFilters}
        />
      ),
      filterIcon: () => <SearchOutlined />,
      onFilter: (value: any, record: any) => {
        return record.productCode ? record.productCode.toString().toLowerCase().includes(value.toLowerCase()) : false;
      },
      sorter: (productA: any, productB: any) => productA.productCode - productB.productCode,
    },
    {
      title: 'Descrição',
      dataIndex: 'productName',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <TableFilters
          inputPlaceholder={'Filtrar pela Descrição'}
          inputValue={selectedKeys[0]}
          onChangeInputValue={setSelectedKeys}
          onFilter={confirm}
          onClearFilters={clearFilters}
        />
      ),
      filterIcon: () => <SearchOutlined />,
      onFilter: (value: any, record: any) => {
        return record.productName ? record.productName.toString().toLowerCase().includes(value.toLowerCase()) : false;
      },
      sorter: (productA: any, productB: any) => productA.productName.trim().localeCompare(productB.productName.trim()),
    },
    {
      title: 'Referência',
      dataIndex: 'referenceCode',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <TableFilters
          inputPlaceholder={'Filtrar pela Referência'}
          inputValue={selectedKeys[0]}
          onChangeInputValue={setSelectedKeys}
          onFilter={confirm}
          onClearFilters={clearFilters}
        />
      ),
      filterIcon: () => <SearchOutlined />,
      onFilter: (value: any, record: any) => {
        return record.referenceCode
          ? record.referenceCode.toString().toLowerCase().includes(value.toLowerCase())
          : false;
      },
      sorter: (productA: any, productB: any) =>
        productA.referenceCode.trim().localeCompare(productB.referenceCode.trim()),
    },
    {
      title: 'Cor',
      dataIndex: 'colorName',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <TableFilters
          inputPlaceholder={'Filtrar pela Cor'}
          inputValue={selectedKeys[0]}
          onChangeInputValue={setSelectedKeys}
          onFilter={confirm}
          onClearFilters={clearFilters}
        />
      ),
      filterIcon: () => <SearchOutlined />,
      onFilter: (value: any, record: any) => {
        return record.colorName ? record.colorName.toString().toLowerCase().includes(value.toLowerCase()) : false;
      },
      sorter: (productA: any, productB: any) => productA.colorName.trim().localeCompare(productB.colorName.trim()),
    },
    {
      title: 'Tamanho',
      dataIndex: 'sizeName',
      align: 'center' as 'center',
      sorter: (productA: any, productB: any) => productA.sizeName.trim().localeCompare(productB.sizeName.trim()),
    },
    {
      title: 'Variação (%)',
      dataIndex: 'variationPercentage',
      align: 'right' as 'right',
      render: (value: any) => (value ? <Text>{value}</Text> : <Text>0</Text>),
      sorter: (productA: any, productB: any) => productA.variationPercentage - productB.variationPercentage,
    },
    {
      title: 'Variação (Valor)',
      dataIndex: 'variationValue',
      align: 'right' as 'right',
      render: (value: any) => (value ? <Text>{value.toFixed(2)}</Text> : <Text>0,00</Text>),
      sorter: (productA: any, productB: any) => productA.variationValue - productB.variationValue,
    },
  ];

  return (
    <Table
      scroll={{ x: 800 }}
      columns={columns}
      dataSource={priceTableProducts}
      pagination={{ defaultPageSize: 4, hideOnSinglePage: true, showSizeChanger: true }}
    />
  );
};

export default TabProduct;
